<!--
 * @Description: 摘要组件
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-ly-abstract">
    <jw-card :bordered="false" v-if="isShowGroup(abstractList)" class="abstract-card">
      <div class="abstract-arrow icon-page-left" v-if="configData.scrollLeft > 0">
        <jw-button type="text" class="icon-btn" status="normal" @click="scrollX(false)">
          <template #icon>
            <qfei-icon-caret-left-outlined class="icon-outlined" />
          </template>
        </jw-button>
      </div>
      <div class="abstract-content" @scroll="handleScroll" ref="abstractContent">
        <div class="abstract-field">
          <abstract-fields :record="abstractList" ref="abstractFieldCom" />
        </div>
      </div>
      <!-- 当前滚动位置 + 容器宽度 < 滚动总宽度时显示 -->
      <div class="abstract-arrow icon-page-right" v-if="configData.clientWidth + configData.scrollLeft < configData.scrollWidth">
        <jw-button type="text" class="icon-btn" status="normal" @click="scrollX(true)">
          <template #icon>
            <qfei-icon-caret-right-outlined class="icon-outlined" />
          </template>
        </jw-button>
      </div>
    </jw-card>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch, inject } from 'vue';

import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
import { QfeiIconCaretRightOutlined } from '@qfei-design/icons-vue';
import AbstractFields from '@/components/fh-set-fields/components/abstract/abstract-field/index.vue';
import fieldPermission from '@/hooks/field-permission';
const { isShowField } = fieldPermission();
const props = defineProps({
  record: {
    //字段列表
    type: Array,
    default: () => []
  }
});
const expandCollapse = inject('detailParams')?.expandCollapse;
const abstractContent = ref(null);
const abstractFieldCom = ref(null);
const abstractList = computed(() => props.record);
const configData = ref({
  scrollLeft: 0, //偏移量
  clientWidth: 0, //总宽度
  scrollWidth: 0 //滚动宽度
});
//配置信息
const ruleFields = inject('detailParams')?.ruleFields;

const validateShow = (field) => {
  let _isFieldShow = false;
  if (field?.type == 20) {
    _isFieldShow = !!isShowField(field?.setting?.fieldKey, ruleFields.value, field?.display);
  }
  return _isFieldShow;
};
// 判断业务规则是否全部隐藏
const isShowGroup = (fields) => {
  let isShow = false;
  fields?.forEach((field) => {
    if (validateShow(field)) {
      isShow = true;
    }
  });
  return isShow;
};

const computeTabWidth = () => {
  configData.value.scrollLeft = 0;
  const container = abstractContent.value;
  if (!container) return;

  // 容器可视宽度
  configData.value.clientWidth = container.clientWidth;
  // 容器内部内容的实际滚动宽度
  configData.value.scrollWidth = container.scrollWidth;
};

// 滚动事件处理函数
const handleScroll = () => {
  const container = abstractContent.value;
  if (!container) return;
  computeTabWidth();

  // 直接取容器的 scrollLeft，确保与实际滚动位置一致
  configData.value.scrollLeft = container.scrollLeft;
};

const scrollX = (isRight) => {
  const { clientWidth, scrollWidth } = configData.value;
  if (clientWidth >= scrollWidth) return; // 内容未超出，无需滚动
  //   abstractFieldCom.value?.hideEdit(); //恢复编辑状态
  const container = abstractContent.value;
  const currentScroll = container.scrollLeft;
  // 最大可滚动距离（总宽度 - 容器宽度）
  const maxScroll = scrollWidth - clientWidth; // 最大可滚动距离
  // 以容器宽度的80%作为滚动步长，适配不同尺寸
  const step = clientWidth * 0.8;

  let targetScroll;
  if (isRight) {
    // 向右滚动：如果当前+步长超过最大范围，则直接滚到最右
    targetScroll = Math.min(currentScroll + step, maxScroll);
  } else {
    // 向左滚动：如果当前-步长小于0，则直接滚到最左
    targetScroll = Math.max(currentScroll - step, 0);
  }

  // 执行滚动
  container.scrollTo({
    left: targetScroll,
    behavior: 'smooth' // 平滑滚动，提升体验
  });
};

onMounted(() => {
  computeTabWidth();
  if (abstractContent.value) {
    abstractContent.value.addEventListener('scroll', handleScroll);
  }
});
// 监听组件卸载，移除滚动事件
onUnmounted(() => {
  if (abstractContent.value) {
    abstractContent.value.removeEventListener('scroll', handleScroll);
  }
});

const updateStatus = () => {
  const container = abstractContent.value;

  if (!container) return;
  container.scrollTo({
    left: 0,
    behavior: 'smooth' // 平滑滚动，提升体验
  });
  computeTabWidth();
};

watch(
  () => expandCollapse.value,
  () => {
    updateStatus();
  },
  { deep: true }
);
eventListener('resize', updateStatus);
</script>
<style scoped lang="less">
@import './index.less';
</style>
<style lang="less">
.comp-ly-abstract {
  .arco-card-body {
    display: flex;
    align-items: center;
    padding: 0 0 24px 0 !important;
  }
}
</style>
